<template>
  <div>
    <menu-pae/>
    <div class="container mt-1">
      <alert-comp :key="alert.key" :msg="alert"/>
    </div>
    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item">
                <router-link to="/workArea">Home</router-link>
              </li>
              <li class="breadcrumb-item">Meus</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-meus class="p-2"
                            :rowsNumber="10"
                            :eventBusDataName="eventBusDataName"
                            :eventBusPaginationName="eventBusPaginationName"/>
    </div>

    <div class="container-xl">
      <data-table-consulta-comp
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :renderizarCheckBox=true
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth"
        :disableCheckbox="disableCheckbox"
        :subtable="subtable">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important; white-space: nowrap;">
            <i
              v-tooltip.auto-start="`Desarmazenar protocolo ${slotProps.itemData.processo}`"
              v-if="desamarzenarIsVisible(slotProps.itemData)"
              class="fa fa-share-square-o fa-1-5x m-1 link text-info"
              aria-hidden="true"
              v-on:click="desarmazenar(slotProps.itemData)"
            ></i>
            <i
              v-if="disableButtomVisualizar(slotProps.itemData)"
              v-tooltip.auto-start="`Visualizar protocolo ${slotProps.itemData.processo}`"
              class="fa fa-search fa-1-5x link m-1 text-info"
              aria-hidden="true"
              v-on:click="visualizar(slotProps.itemData)"
            ></i>
            <i
              v-tooltip.auto-start="`Desatribuir protocolo ${slotProps.itemData.processo}`"
              v-if="desatribuirIsVisible(slotProps.itemData)"
              class="fa fa-backward fa-1-5x link m-1 text-warning"
              aria-hidden="true"
              v-on:click="desatribuir(slotProps.itemData)"
            ></i>
            <i
              v-tooltip.auto-start="`Desarquivar protocolo ${slotProps.itemData.processo}`"
              v-if="desarquivarProtocoloIsVisible(slotProps.itemData)"
              class="fa fa-inbox fa-1-5x link m-1 text-warning"
              aria-hidden="true"
              v-on:click="abrirModalDesarquivamento(slotProps.itemData)"
            ></i>
            <i
              v-tooltip.auto-start="`Editar arquivamento protocolo ${slotProps.itemData.processo}`"
              v-if="editarArquivamentoProtocoloIsVisible(slotProps.itemData)"
              class="fa fa-edit fa-1-5x link m-1 text-warning"
              aria-hidden="true"
              v-on:click="abrirModalEditarArquivamento(slotProps.itemData)"
            ></i>
            <i
              v-tooltip.auto-start="`Editar eliminação do protocolo ${slotProps.itemData.processo}`"
              v-if="editarEliminacaoProtocoloIsVisible(slotProps.itemData)"
              class="fa fa-ban fa-1-5x link m-1 text-danger"
              aria-hidden="true"
              v-on:click="abrirModalEditarEliminacao(slotProps.itemData)"
            ></i>
            <i
              v-tooltip.auto-start="`Desfazer eliminação do protocolo ${slotProps.itemData.processo}`"
              v-if="desfazerEliminacaoProtocoloIsVisible(slotProps.itemData)"
              class="fa fa-undo fa-1-5x link m-1 text-warning"
              aria-hidden="true"
              v-on:click="abrirModalDesfazerEliminacao(slotProps.itemData)"
            ></i>
            <i
              v-tooltip.auto-start="`Abrir Observações ${slotProps.itemData.processo}`"
              class="fa fa-exclamation-triangle fa-1-5x link m-1 text-warning"
              aria-hidden="true"
              v-on:click="abrirModalObservacao(slotProps.itemData)"
            ></i>
          </td>
        </template>
        <template v-slot:subtable="subtable">
          <i
            v-tooltip.auto-start="`Visualizar protocolo ${subtable.itemData.data ? subtable.itemData.data.protocolo : ''}`"
            class="fa fa-search fa-1-5x link m-1 text-info"
            aria-hidden="true"
            v-on:click="visualizarApensado(subtable.itemData)"
          ></i>
        </template>
      </data-table-consulta-comp>

      <div class="row btn-acoes mb-2">
        <div class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
          <button class="btn btn-outline-primary w-150-min" @click.prevent="tramitar"> Tramitar</button>
        </div>
        <div>
          <div v-if="eliminarChecked.error === 0" class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
            <button class="btn btn-outline-primary w-150-min" @click.prevent="abrirModalEliminacao">Eliminar</button>
            <button class="btn btn-outline-success w-50-min" v-tooltip.auto-start="`Não há nenhuma pendência`"><i class="fa fa-check" aria-hidden="true"></i></button>
          </div>
          <div v-if="eliminarChecked.error !== 0" class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
            <button class="btn btn-outline-dark w-150-min disable">Eliminar</button>
            <button class="btn btn-outline-danger w-50-min" v-tooltip.auto-start="eliminarChecked.message"><i class="fa fa-exclamation" aria-hidden="true"></i></button>
          </div>
        </div>
        <div>
          <div v-if="arquivarChecked.error === 0" class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
            <button class="btn btn-outline-primary w-150-min" @click.prevent="abrirModalArquivamento">Arquivar</button>
            <button class="btn btn-outline-success w-50-min" v-tooltip.auto-start="`Não há nenhuma pendência`"><i class="fa fa-check" aria-hidden="true"></i></button>
          </div>
          <div v-if="arquivarChecked.error !== 0" class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
            <button class="btn btn-outline-dark w-150-min disable">Arquivar</button>
            <button class="btn btn-outline-danger w-50-min" v-tooltip.auto-start="arquivarChecked.message"><i class="fa fa-exclamation" aria-hidden="true"></i></button>
          </div>
        </div>
        <div>
          <div v-if="armazenarChecked.error === 0" class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
            <button class="btn btn-outline-primary w-150-min" @click.prevent="abrirModalArmazenamento">Armazenar</button>
            <button class="btn btn-outline-success w-50-min" v-tooltip.auto-start="`Não há nenhuma pendência`"><i class="fa fa-check" aria-hidden="true"></i></button>
          </div>
          <div v-if="armazenarChecked.error !== 0" class="btn-group btn-group-toggle mr-2" data-toggle="buttons">
            <button class="btn btn-outline-dark w-150-min disable">Armazenar</button>
            <button class="btn btn-outline-danger w-50-min" v-tooltip.auto-start="armazenarChecked.message"><i class="fa fa-exclamation" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div>

    <modal ref="arquivarTramitacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Arquivar Protocolo</h4>
          <i class="fa fa-times fa-1-5x" @click="() => closeModal($refs.arquivarTramitacao.closeModal)"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <arquivar :closeModalEvent="() => closeModal($refs.arquivarTramitacao.closeModal)"
                    :atualizarConsulta="atualizarConsulta"/>
        </div>
      </template>
    </modal>

    <modal ref="desarquivarTramitacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Desarquivar Protocolo</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.desarquivarTramitacao.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <desarquivar :closeModalEvent="$refs.desarquivarTramitacao.closeModal" :protocolo="protocoloSelecionado"
                       :atualizarConsulta="atualizarConsulta"/>
        </div>
      </template>
    </modal>

    <modal ref="editarArquivamentoTramitacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Editar Arquivamento</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.editarArquivamentoTramitacao.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <editar-arquivamento :closeModalEvent="$refs.editarArquivamentoTramitacao.closeModal"
                               :protocolo="protocoloSelecionado" :atualizarConsulta="atualizarConsulta"/>
        </div>
      </template>
    </modal>

    <modal ref="eliminarTramitacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Eliminar Protocolo</h4>
          <i class="fa fa-times fa-1-5x" @click="() => closeModal($refs.eliminarTramitacao.closeModal)"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <eliminar :closeModalEvent="() => closeModal($refs.eliminarTramitacao.closeModal)"
                    :atualizarConsulta="atualizarConsulta"/>
        </div>
      </template>
    </modal>

    <modal ref="editarEliminarTramitacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Editar Eliminação Protocolo</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.editarEliminarTramitacao.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <eliminar :closeModalEvent="$refs.editarEliminarTramitacao.closeModal" :protocolo="protocoloSelecionado"
                    :editar-eliminacao="eliminacaoParaEditar" :atualizarConsulta="atualizarConsulta"/>
        </div>
      </template>
    </modal>

    <modal ref="desfazerEliminarTramitacao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Desfazer Eliminação Protocolo</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.desfazerEliminarTramitacao.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <desfazer-eliminacao :closeModalEvent="$refs.desfazerEliminarTramitacao.closeModal"
                               :protocolo="protocoloSelecionado" :atualizarConsulta="atualizarConsulta"/>
        </div>
      </template>
    </modal>

    <modal ref="devolverTramitacao" width="1000px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Devolver Protocolos</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.devolverTramitacao.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <devolver :closeModalEvent="$refs.devolverTramitacao.closeModal"/>
        </div>
      </template>
    </modal>

    <modal ref="armazenarProtocolo" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Armazenar protocolo</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.armazenarProtocolo.closeModal()"/>
        </div>
      </template>
      <template v-slot:body>
        <div class="modal-body">
          <armazenar :closeModalEvent="() => closeModal($refs.armazenarProtocolo.closeModal)" :atualizarConsulta="atualizarConsulta"
           />
        </div>
      </template>
    </modal>

    <modal ref="observacao" width="1000px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Observações</h4>
          <i class="fa fa-times fa-1-7x m-2 link" @click="$refs.observacao.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <observacao :numeroProcesso="protocoloSelecionado"/>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaMeus from '@/components/consulta-processo/FiltroPesquisaMeus.vue'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsulta'
import VirtusService from '@/services/VirtusService'
import eventBus from '@/uteis/eventBus'
import modal from '@/components/shared/Modal'
import alertComp from '@/components/alert/AlertComp'
import devolver from '@/components/devolver/Devolver'
import arquivar from '@/components/arquivar/Arquivar'
import desarquivar from '@/components/desarquivar/Desarquivar'
import editarArquivamento from '@/components/editarArquivamento/EditarArquivamento'
import eliminar from '@/components/eliminar/Eliminar'
import desfazerEliminacao from '@/components/eliminar/DesfazerEliminacao'
import observacao from '@/components/observacoes/Observacao'

import { componentIsVisible, rules } from '@/uteis/action/permissao'
import armazenar from '../../components/armazenar/Armazenar.vue'

export default {
  name: 'meus',
  components: {
    menuPae,
    filtroPesquisaMeus,
    dataTableConsultaComp,
    modal,
    alertComp,
    devolver,
    arquivar,
    desarquivar,
    editarArquivamento,
    eliminar,
    desfazerEliminacao,
    observacao,
    armazenar
  },

  data () {
    return {
      colNames: ['Remetente', 'Nº Protocolo', 'Tipo Protocolo', 'Assunto', 'Interessados', 'Data Envio', 'Ações'],
      eventBusDataName: 'consultaProcessoMeus',
      eventBusPaginationName: 'consultaProcessoMeusDataPagination',
      colWidth: [20, 10, 10, 20, 15, 10, 15],
      dataTableColumn: ['atributos.origem.titulo',
        {
          column: 'processo',
          converter: 'protocolo'
        },
        'atributos.tipoProtocolo',
        'atributos.assunto',
        {
          column: 'atributos.interessados.[nome]',
          converter: 'interessados'
        },
        {
          column: 'ultimaTramitacao.data',
          converter: 'localDate'
        }],
      armazenamento: {
        local: '',
        motivo: '',
        numeroProcesso: '',
        nomeUsuario: '',
        usuarioCriacao: ''
      },
      alert: {
        type: '',
        texto: '',
        key: true
      },
      protocoloSelecionado: '',
      eliminacaoParaEditar: '',
      errosValidacaoArmazenamento: [],
      erroValicaoArmazenamentoLocal: '',
      erroValicaoArmazenamentoMotivo: '',
      subtable: {
        field: 'processosApensados',
        column: [
          {
            $set: 'Apenso'
          },
          {
            column: 'protocolo',
            converter: 'protocolo'
          },
          'tipoProtocolo',
          'assunto', {
            column: 'interessados.[nome]',
            converter: 'interessados'
          }
        ]
      }
    }
  },

  computed: {
    eliminarChecked: function () {
      const dataTable = this.$store.getters.getDataTableChecked
      const checked = {
        error: 0,
        message: ''
      }

      if (dataTable.length === 0) {
        checked.error = -1
        checked.message = 'Nenhum protocolo selecionado'

        return checked
      }

      const protocolos = []
      for (const value of dataTable) {
        const processo = value.data
        const numeroProcesso = value.data.processo

        if (this.possuiApensados(processo)) {
          protocolos.push(numeroProcesso)
          checked.error++
        }
      }

      checked.message = `Protocolos com apensos não podem ser eliminados: ${protocolos.join(', ')}`
      return checked
    },

    arquivarChecked: function () {
      const dataTable = this.$store.getters.getDataTableChecked
      const checked = {
        error: 0,
        message: ''
      }

      if (!componentIsVisible(this.ARQUIVAR_PROTOCOLO)) {
        checked.error = -1
        checked.message = 'Você não tem a permissão para executar essa ação'

        return checked
      }

      if (dataTable.length === 0) {
        checked.error = -1
        checked.message = 'Nenhum protocolo selecionado'

        return checked
      }

      const protocolos = []
      for (const value of dataTable) {
        const processo = value.data
        const numeroProcesso = value.data.processo

        if (this.possuiApensados(processo)) {
          protocolos.push(numeroProcesso)
          checked.error++
        }
      }

      checked.message = `Protocolos com apensos não podem ser arquivados: ${protocolos.join(', ')}`
      return checked
    },

    armazenarChecked: function () {
      const dataTable = this.$store.getters.getDataTableChecked
      const checked = {
        error: 0,
        message: ''
      }

      if (dataTable.length === 0) {
        checked.error = -1
        checked.message = 'Nenhum protocolo selecionado'

        return checked
      }

      const protocolos = []
      const anexados = []

      for (const value of dataTable) {
        const processo = value.data
        const numeroProcesso = value.data.processo

        if (this.possuiApensados(processo)) {
          protocolos.push(numeroProcesso)
          checked.error++
        }

        if (this.isApensado(processo)) {
          protocolos.push(numeroProcesso)
          checked.error++
        }

        if (this.isAnexado(processo)) {
          anexados.push(numeroProcesso)
          checked.error++
        }
      }

      checked.message = `Protocolos com apensos ou apensados não podem ser armazenados: ${protocolos.join(', ')}`

      if (anexados.length > 0) {
        checked.message = `${checked.message} | Protocolos anexados não podem ser armazenados: ${anexados.join(', ')}`
      }
      return checked
    }
  },

  created () {
    this.service = new VirtusService()
    const { ARQUIVAR_PROTOCOLO, DESFAZER_ELIMINACAO } = rules
    this.ARQUIVAR_PROTOCOLO = ARQUIVAR_PROTOCOLO
    this.DESFAZER_ELIMINACAO = DESFAZER_ELIMINACAO
  },

  methods: {
    closeModal (functionCloseModal) {
      functionCloseModal()
      this.atualizarConsulta()
    },

    abrirModalArquivamento () {
      this.$refs.arquivarTramitacao.openModal()
    },

    abrirModalDesarquivamento (obj) {
      this.protocoloSelecionado = obj.processo
      this.$refs.desarquivarTramitacao.openModal()
    },

    abrirModalEditarArquivamento (obj) {
      this.protocoloSelecionado = obj.processo
      this.$refs.editarArquivamentoTramitacao.openModal()
    },

    abrirModalEliminacao () {
      this.$refs.eliminarTramitacao.openModal()
    },

    abrirModalEditarEliminacao (obj) {
      /* TODO Alan, desculpa, fiz assim pq estava sem saída. Just for Ninjas. Depois vamos rever isso ? */
      while (this.$store.getters.getDataTableChecked.length > 0) {
        this.$store.getters.getDataTableChecked.pop()
      }
      this.protocoloSelecionado = obj.processo
      this.eliminacaoParaEditar = obj.atributos.remocao
      this.$refs.editarEliminarTramitacao.openModal()
    },

    abrirModalDesfazerEliminacao (obj) {
      /* TODO Alan, desculpa, fiz assim pq estava sem saída. Just for Ninjas. Depois vamos rever isso ? */
      while (this.$store.getters.getDataTableChecked.length > 0) {
        this.$store.getters.getDataTableChecked.pop()
      }
      this.protocoloSelecionado = obj.processo
      this.$refs.desfazerEliminarTramitacao.openModal()
    },

    abrirModalObservacao (obj) {
      /* TODO Alan, desculpa, fiz assim pq estava sem saída. Just for Ninjas. Depois vamos rever isso ? */
      while (this.$store.getters.getDataTableChecked.length > 0) {
        this.$store.getters.getDataTableChecked.pop()
      }
      this.protocoloSelecionado = obj.processo
      this.$refs.observacao.openModal()
    },

    abrirModalArmazenamento (obj) {
      this.armazenamento.numeroProcesso = obj.processo
      if (obj.apensadoEm || obj.apensados) {
        this.alert = {
          type: 'warning',
          texto: 'Não podemos armazenar. Protocolo está apensado ou possui protocolos apensados.',
          key: !this.alert.key
        }
      } else if (this.isAnexado(obj)) {
        this.alert = {
          type: 'warning',
          texto: 'Não podemos armazenar. Protocolo está Anexado a um outro protocolo.',
          key: !this.alert.key
        }
      } else {
        this.$refs.armazenarProtocolo.openModal()
      }
    },

    devolver () {
      const processosSelecionados = this.$store.getters.getDataTableChecked
      if (processosSelecionados.length > 0) {
        this.$refs.devolverTramitacao.openModal()
      }
    },

    armazenar (obj) {
      if (this.validarArmazenamento()) {
        const dadosSessao = this.$store.getters.getDadosSessao
        this.armazenamento.usuarioCriacao = dadosSessao.sessao.login
        this.armazenamento.nomeUsuario = dadosSessao.sessao.nomeUsuario
        this.service.armazenar(this.armazenamento).then(res => {
          this.limparArmazenamento()
          this.$refs.armazenarProtocolo.closeModal()
          this.atualizarConsulta()
        }).catch(err => {
          console.log(err)
        })
      }
    },

    limparArmazenamento () {
      this.armazenamento.local = ''
      this.armazenamento.motivo = ''
      this.armazenamento.numeroProcesso = ''
      this.armazenamento.nomeUsuario = ''
      this.armazenamento.usuarioCriacao = ''
      this.erroValicaoArmazenamentoLocal = ''
      this.erroValicaoArmazenamentoMotivo = ''
      this.errosValidacaoArmazenamento = []
    },

    desarmazenar (obj) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.service.desarmazenar(obj.processo, dadosSessao.sessao).then(res => {
        this.atualizarConsulta()
      }).catch(err => {
        console.log(err)
      })
    },

    visualizarApensado (obj) {
      var data = obj.data
      var disable = true
      this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
        volume: data.tipoProtocolo === 'Processo',
        anexar: true,
        protocoloTipoProcesso: data.tipoProtocolo === 'Processo'
      })
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: data.protocolo.replace(/\//g, ''),
          disableMenuProcesso: disable,
          tramitado: true
        }
      })
    },

    visualizar (obj) {
      var disable = (this.isApensado(obj) || this.isAnexado(obj) || this.isArmazenado(obj) || this.isArquivado(obj) || this.isEliminado(obj))
      this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
        volume: obj.atributos.tipoProtocolo === 'Processo',
        anexar: true,
        protocoloTipoProcesso: obj.atributos.tipoProtocolo === 'Processo',
        editarProtocolo: true
      })
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: obj.processo.replace(/\//g, ''),
          disableMenuProcesso: disable,
          tramitado: true
        }
      })
    },

    async desatribuir (processo) {
      const dadosSessao = this.$store.getters.getDadosSessao

      await this.service.desatribuirProcessos(processo, dadosSessao.sessao)
      await this.service.registrarDesatribuicaoNoHistorico(dadosSessao.sessao, processo)

      this.atualizarConsulta()
    },

    atualizarConsulta () {
      eventBus.$emit(this.eventBusPaginationName, 1, 'RESET_SELECTED')
    },

    tramitar () {
      const processosSelecionados = this.$store.getters.getDataTableChecked
      if (processosSelecionados.length > 0) {
        var numeroProcessos = processosSelecionados.map((data) => data.data.processo)
        this.$store.commit('MUT_PROCESSOS_TRAMITACAO', numeroProcessos)
        this.$router.push({ name: 'tramite' })
      }
    },

    disableButtomVisualizar (obj) {
      if (!obj.atributos) {
        return false
      }

      return true
    },

    disableCheckbox (protocolo) {
      if (!protocolo.data) {
        return false
      }

      if (this.isEliminado(protocolo.data)) {
        return false
      }

      return !(this.isApensado(protocolo.data) || this.isAnexado(protocolo.data) || protocolo.data.atributos.armazenado || protocolo.data.atributos.arquivado)
    },

    validarArmazenamento () {
      this.erroValicaoArmazenamentoLocal = ''
      this.erroValicaoArmazenamentoMotivo = ''
      this.errosValidacaoArmazenamento = []
      if (!this.armazenamento.local) {
        this.erroValicaoArmazenamentoLocal = '*Local Obrigatório'
        this.errosValidacaoArmazenamento.push('Informar Local do Armazenamento.')
      }

      if (!this.armazenamento.motivo) {
        this.erroValicaoArmazenamentoMotivo = '*Motivo Obrigatório'
        this.errosValidacaoArmazenamento.push('Informar Motivo do Armazenamento.')
      }

      if (!this.errosValidacaoArmazenamento.length) {
        return true
      }
    },

    arquivarProtocoloIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      if (componentIsVisible(this.ARQUIVAR_PROTOCOLO)) {
        return !(this.isApensado(data) || this.possuiApensados(data) || this.isAnexado(data) || this.isArmazenado(data) || this.isArquivado(data) || this.isEliminado(data))
      }

      return false
    },

    desarquivarProtocoloIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      if (componentIsVisible(this.ARQUIVAR_PROTOCOLO)) {
        return this.isArquivado(data)
      }

      return false
    },

    editarArquivamentoProtocoloIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      if (componentIsVisible(this.ARQUIVAR_PROTOCOLO)) {
        return this.isArquivado(data)
      }

      return false
    },

    eliminarProtocoloIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      return !(this.isApensado(data) || this.possuiApensados(data) || this.isAnexado(data) || this.isArmazenado(data) || this.isArquivado(data) || this.isEliminado(data))
    },

    editarEliminacaoProtocoloIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      return this.isEliminado(data)
    },

    desfazerEliminacaoProtocoloIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      if (componentIsVisible(this.DESFAZER_ELIMINACAO)) {
        return this.isEliminado(data)
      }

      return false
    },

    desamarzenarIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      return this.isArmazenado(data)
    },

    desatribuirIsVisible (data) {
      if (!data.atributos) {
        return false
      }

      return !(this.isApensado(data) || this.isAnexado(data))
    },

    possuiApensados: (obj) => obj.apensados && obj.apensados.length > 0,
    isApensado: (obj) => obj.apensadoEm && obj.apensadoEm !== '',
    isAnexado: (obj) => obj.anexadoEm && obj.anexadoEm !== '',
    isArmazenado: (obj) => obj.atributos.armazenado,
    isArquivado: (obj) => obj.atributos.arquivado,
    isEliminado: (obj) => obj.atributos.remocao
  }
}
</script>

<style scoped lang="scss">
.erro {
  color: orange;
}
</style>
